export default __webpack_public_path__ + "static/media/kristen_clark.6099835f.gif";